/* eslint-disable import/prefer-default-export */
import trackError from '@helpers/trackError'
import { getProductCategory } from '@spokeldn/common-sku-functions'
import { analytics } from '@helpers/analytics'

type EventProps = Record<string, unknown>

function event(name: string, eventProps: EventProps = {}) {
  try {
    analytics(name, eventProps)
  } catch (e) {
    trackError(e as Error, { section: 'Returns' })
  }
}

export function returnsAnalytics(name: string, eventProps: EventProps = {}) {
  event(name, {
    context: 'React',
    ...eventProps
  })
}

export function returnsClickEvent(eventProps: EventProps = {}) {
  event('Click', {
    category: 'Returns',
    ...eventProps
  })
}

const EXCLUDED_PRODUCT_CATEGORIES = ['shorts'] as const

export function isAllowedProductCategoryBySku(sku: string) {
  const category = getProductCategory(sku)
  if (!category) return true
  return !EXCLUDED_PRODUCT_CATEGORIES.includes(category.toLowerCase())
}
